<template>
  <div id="app">
    <!-- 仅当不在注册页或登录页时显示导航栏 -->
    <div v-if="showNavbar" class="navbar">
      <div class="navtitle">
        <!-- <img src="./assets/home/logo_1.png" alt=""> -->
        <div class="title">
          <div>铁岭县华盛城乡建设有限公司</div>
          <div>
           Tieling County Huasheng Urban and Rural Construction CoLtd
          </div>
        </div>

        <!-- 登录状态显示区域 -->
        <div class="user-info" v-if="isLoggedIn">
          <!-- <span class="username">{{ userName }}</span> -->
           <router-link to="/zuce" class="username">{{ userName }}</router-link>
          <button class="logout-btn" @click="logout">退出登录</button>
        </div>
        <!-- 未登录时显示登录按钮 -->
        <div class="login-container" v-else>
          <button class="login-btn" @click="goToLogin">登录</button>
        </div>
      </div>

      <div class="tabs">
        <div
          class="tab-item"
          v-for="(item, index) in navTabs"
          :key="index"
          @click="chooseNavbar(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <transition name="fade">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import { getNavlist, supplier_logout } from "@/api/index";
export default {
  data() {
    return {
      navTabs: [],
      chooseStyle: {
        color: " #0C1DBBFF",
        background: "#fff",
        borderBottom: "13px solid #0C1DBBFF",
      },
      showNavbar: true,
      isLoggedIn: false, // 登录状态
      userName: "", // 用户名
      loading: false, // 加载状态
    };
  },
  created() {
    console.log('created钩子执行');
    this.navList();
    this.checkRouteAndUpdateNavbar();
    this.$router.afterEach(() => {
      this.checkRouteAndUpdateNavbar();
    });
    // 检查本地存储中的登录状态
    this.checkLoginStatus();
    console.log("登录状态:", this.isLoggedIn, "用户名:", this.userName);
  },
  methods: {
    // 获取导航栏数据
    async navList() {
      try {
        const res = await getNavlist();
        console.log(res, "导航数据");
        this.navTabs = res.list;

        // 添加固定导航项
        const fixedTabs = [
          { a: "", c: "", id: 0, name: "首页" },
          // { a: "", c: "", id: 0, name: "数字政协" },
          // { name: "供应商入驻" },
          // { name: "招标" },
          // { name: "登录" },
        ];

        this.navTabs = [...fixedTabs, ...this.navTabs];
      } catch (error) {
        console.error("获取导航数据失败", error);
      }
    },

    // 检查路由并更新导航栏显示状态
    checkRouteAndUpdateNavbar() {
      this.showNavbar = !(
        this.$route.path.startsWith("/zuce") || this.$route.path.startsWith("/login")
      );
    },

    // 处理导航栏点击
    chooseNavbar(e) {
      switch (e.name) {
        case "首页":
          this.$router.push("/");
          break;
        // case "数字政协":
        //   window.open("https://example.com");
        //   break;
        case "供货商入驻":
          this.$router.push(`/merchant`);
          break;
          case "招标公示":
          this.$router.push(`/zhaobiao`);
          break;
        case "登录":
          this.$router.push(`/login`);
          break;
        case "视听政协":
          this.$router.push(`video?navname=${e.name}&c=${e.c}&a=${e.a}`);
          break;
        default:
          this.$router.push(`news?navname=${e.name}&c=${e.c}&a=${e.a}`);
          break;
      }
    },

    // 检查登录状态
    checkLoginStatus() {
      const username = localStorage.getItem("username");
      console.log(username, "用户信息");

      if (username) {
        try {
          // const parsedInfo = JSON.parse(username);
          this.isLoggedIn = true;
          this.userName = username || "用户";
        } catch (error) {
          console.error("解析用户信息失败", error);
          this.clearLoginState();
        }
      } else {
        this.clearLoginState();
      }
    },

    // 处理登录
    handleLogin(username) {
      // 保存用户信息到本地存储
      localStorage.setItem("username", username);
      this.isLoggedIn = true;
      this.userName = username;
      this.$router.push("/");
    },

    // 退出登录
    async logout() {
      this.loading = true;

      try {
        const iid = localStorage.getItem("id");
        if (iid) {
          // 修复：将iid改为id，确保参数名正确
          await supplier_logout({ id: iid });
          console.log("退出登录接口调用成功");
        } else {
          console.warn("本地存储中没有找到用户ID");
        }
      } catch (error) {
        console.error("退出登录接口调用失败", error);
        // 即使接口调用失败，也清除本地登录状态
      } finally {
        // 清除本地存储和登录状态
        this.clearLoginState();
        localStorage.removeItem("username");
        localStorage.removeItem("id");
        localStorage.removeItem("token");

        this.loading = false;
        this.$router.replace("/");
      }
    },

    // 前往登录页
    goToLogin() {
      this.$router.replace("/login");
    },

    // 清除登录状态
    clearLoginState() {
      this.isLoggedIn = false;
      this.userName = "";
    },
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100vh;
  margin: 0;
  padding: 0;
}
.navbar {
  z-index: 999;
  position: fixed;
  top: 0;
  width: 100vw;
  height: 23vh;
  background-image: url(./assets/home/bg.png);
  background-repeat: no-repeat;
  background-size: cover;

  .navtitle {
    height: 65%;
    border-bottom: 2px solid #fff3c3;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: space-between;
    padding: 0 3vw;

    .title {
      color: #f5f5f5ff;
      margin-left: 25vw;

      :nth-child(1) {
        font-size: 2.4vw;
        font-weight: 600;
      }

      :nth-child(2) {
        font-size: 1.4vw;
      }
    }

    img {
      width: 12.6vw;
      height: 12.2vw;
    }

    // 用户信息区域样式
    .user-info {
      display: flex;
      align-items: center;
      color: white;
      font-size: 1.2vw;

      .username {
        color:#fff;
        margin-right: 15px;
        font-weight: 500;
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .logout-btn {
        background-color: #2E79DCFF;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 15px;
        cursor: pointer;
        font-size: 1vw;
        transition: all 0.3s ease;
        position: relative;

        &:hover {
          background-color: #1B79D8FF;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        // 加载状态样式
        &.loading::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          width: 12px;
          height: 12px;
          border: 2px solid white;
          border-radius: 50%;
          border-top-color: transparent;
          animation: spin 1s linear infinite;
        }
      }
    }

    // 登录按钮样式
    .login-container {
      .login-btn {
        background-color: rgba(255, 255, 255, 0.2);
        color: white;
        border: 1px solid rgba(255, 255, 255, 0.4);
        border-radius: 4px;
        padding: 8px 15px;
        cursor: pointer;
        font-size: 1vw;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(255, 255, 255, 0.3);
          transform: translateY(-2px);
        }
      }
    }
  }

  .tabs {
    display: flex;
    height: 35%;
    
    .tab-item {
      flex: 1;
      cursor: pointer;
      padding-top: 2.3vh;
      text-align: center;
      font-size: 0.18rem;
      font-weight: 600;
      color: #ffffffff;
      position: relative;
      
      /* 添加分隔线 */
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        height: 50%;
        width: 1px;
        background-color: #fdac6e;
        transform: translateY(-50%);
      }
      
      &:last-child::after {
        display: none; /* 最后一个标签不显示分隔线 */
      }
      
      &:hover {
        height: 100%;
        color: #372727ff;
        background: #fff;
        border-bottom: 13px solid #204FDCFF;
      }
    }
  }
}

body::-webkit-scrollbar {
  width: 0;
}
#app {
  height: 100vh;
  font-family: SourceHanSansCN;
}
.fade-enter,
.fade-leave-to {
  visibility: hidden;
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-to,
.fade-leave {
  visibility: visible;
  opacity: 1;
}

// 加载动画
@keyframes spin {
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}
</style>